module.exports = __webpack_public_path__ + "static/metrics-9e0ab2bdd7931ae037e315135da24699.jpg";